export default {
  nav: {
    home: "Accueil",
    spreadsheet: "Tableur",
    categories: "Catégories",
    guides: "Guides",
    comparisons: "Comparaisons",
    safety: "Sécurité",
    faq: "FAQ",
    search: "Rechercher",
    language: "Langue",
    cta: "Explorer le Tableur",
  },
  categories: {
    shoes: "Chaussures",
    hoodies: "Sweats à Capuche / Pulls",
    tshirts: "T-Shirts",
    jackets: "Vestes",
    pants: "Pantalons / Shorts",
    headwear: "Couvre-Chefs",
    sets: "Ensembles",
    underwear: "Sous-Vêtements",
    jersey: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres Articles",
  },
  hero: {
    eyebrow: "LE CENTRE DE RECHERCHE ALLCHINABUY",
    h1: "AllChinaBuy Spreadsheet — Trouvez des Produits, Vendeurs et Ressources d'Achat Plus Vite",
    subheadline: "Explorez le tableur AllChinaBuy, les guides de recherche produit, les ressources vendeur, les conseils QC, les informations d'expédition et les dernières ressources d'achat — tout organisé en un seul endroit.",
    ctaPrimary: "Explorer le Tableur AllChinaBuy",
    ctaSecondary: "Parcourir les Guides d'Achat",
    trust: "Ressources mises à jour • Recherche produit • Guides QC • Informations d'expédition • Ressources sécurité",
    searchPlaceholder: "Rechercher des produits, vendeurs, guides d'expédition ou ressources AllChinaBuy...",
  },
  valueProp: {
    h2: "Tout Ce Dont Vous Avez Besoin pour Rechercher des Produits AllChinaBuy",
    copy: "Trouver des produits n'est que la première étape. Notre centre de ressources AllChinaBuy vous aide à rechercher des produits, comparer les options, comprendre les informations QC, explorer les méthodes d'expédition et prendre de meilleures décisions d'achat.",
    cta: "Explorer Toutes les Ressources",
    cards: {
      spreadsheet: {
        title: "AllChinaBuy Spreadsheet",
        desc: "Trouvez des ressources de produits et de recherche organisées.",
      },
      research: {
        title: "Recherche Produit",
        desc: "Apprenez à évaluer les produits avant de commander.",
      },
      sellers: {
        title: "Guides Vendeur",
        desc: "Comprenez les informations vendeur et la sélection de produits.",
      },
      qc: {
        title: "Ressources QC",
        desc: "Apprenez quoi chercher lors de l'examen des informations de contrôle qualité.",
      },
      shipping: {
        title: "Guides d'Expédition",
        desc: "Comprenez les options d'expédition, les coûts et les considérations importantes.",
      },
      safety: {
        title: "Centre de Sécurité",
        desc: "Apprenez des moyens pratiques pour réduire les risques d'achat et de sécurité courants.",
      },
    },
  },
  spreadsheetPreview: {
    h2: "AllChinaBuy Spreadsheet",
    copy: "Le tableur AllChinaBuy est la ressource centrale pour découvrir des produits, organiser la recherche et trouver des informations d'achat utiles. Utilisez-le comme point de départ, puis explorez nos guides détaillés avant de prendre des décisions d'achat.",
    cta: "Ouvrir le Tableur AllChinaBuy",
    columns: {
      product: "Produit",
      category: "Catégorie",
      seller: "Vendeur",
      status: "Statut de Recherche",
      qc: "Ressource QC",
      guide: "Guide",
      updated: "Mis à Jour",
    },
  },
  trust: {
    h2: "Pourquoi Utiliser ce Centre de Ressources AllChinaBuy ?",
    cards: {
      organized: {
        title: "Recherche Organisée",
        desc: "Les ressources sont regroupées par produit, catégorie, vendeur, QC, expédition et intention d'achat.",
      },
      comparisons: {
        title: "Comparaisons Utiles",
        desc: "Des tableaux clairs aident les utilisateurs à comprendre les différences entre les options.",
      },
      updated: {
        title: "Contenu Mis à Jour",
        desc: "Affichez les dates de publication et de mise à jour.",
      },
      safetyFirst: {
        title: "Sécurité d'Abord",
        desc: "Fournit des informations pratiques sur la recherche de produits, les paiements, les comptes et l'expédition.",
      },
      multilingual: {
        title: "Multilingue",
        desc: "Versions en anglais, français, danois et allemand.",
      },
      independent: {
        title: "Ressource Indépendante",
        desc: "Divulgue clairement la relation du site avec le site principal lorsque cela s'applique.",
      },
    },
  },
  comparison: {
    h2: "Ressources AllChinaBuy en un Coup d'Œil",
    cta: "Explorer le Centre de Ressources Complet",
    headers: {
      resource: "Ressource",
      bestFor: "Idéal Pour",
      info: "Information",
    },
    rows: {
      spreadsheet: { name: "AllChinaBuy Spreadsheet", bestFor: "Découverte de produits", info: "Produits & recherche" },
      productGuides: { name: "Guides Produit", bestFor: "Recherche produit", info: "Considérations d'achat" },
      qcGuides: { name: "Guides QC", bestFor: "Contrôle qualité", info: "Principes QC" },
      shippingGuides: { name: "Guides d'Expédition", bestFor: "Recherche d'expédition", info: "Méthodes & facteurs" },
      warehouseGuide: { name: "Guide Entrepôt", bestFor: "Information entrepôt", info: "Stockage & traitement" },
      safetyGuide: { name: "Guide Sécurité", bestFor: "Conscience des risques", info: "Sécurité & sûreté" },
    },
  },
  reviewSection: {
    h2: "Avis AllChinaBuy : Que Devraient Savoir les Acheteurs ?",
    copy: "Avant d'utiliser une plateforme d'achat, il est important de comprendre comment fonctionnent la recherche de produits, la commande, le QC, le traitement d'entrepôt et l'expédition. Notre contenu d'avis AllChinaBuy se concentre sur des informations pratiques plutôt que des affirmations non fondées.",
    cta: "Lire l'Avis AllChinaBuy",
  },
  shippingSection: {
    h2: "Coût d'Expédition & Guide d'Expédition AllChinaBuy",
    copy: "Les coûts d'expédition peuvent varier selon la destination, la taille du colis, le poids, la méthode d'expédition et d'autres facteurs. Apprenez comment fonctionne l'expédition, ce qui peut affecter le coût final et comment comparer les options disponibles.",
    cta: "Voir le Guide d'Expédition AllChinaBuy",
  },
  couponSection: {
    h2: "Coupon & Code de Réduction AllChinaBuy",
    copy: "Vous cherchez des coupons ou codes de réduction AllChinaBuy ? Consultez nos dernières ressources de coupons et promotions avant de commander. Vérifiez toujours si une offre est actuelle, valide et soumise à des conditions spécifiques.",
    cta: "Vérifier les Coupons & Réductions",
  },
  warehouseSection: {
    h2: "Guide Entrepôt AllChinaBuy",
    copy: "Comprenez comment le stockage d'entrepôt, l'inspection de produits, le traitement et la préparation d'expédition s'intègrent dans le processus d'achat.",
    cta: "Explorer le Guide Entrepôt",
  },
  safetySection: {
    h2: "AllChinaBuy est-il Légitime & Sûr ?",
    copy: "Rechercher si une plateforme est légitime devrait impliquer plus qu'une simple réponse oui ou non. Apprenez ce qu'il faut vérifier, comment protéger votre compte et vos informations de paiement, comment évaluer les informations sur les produits et quels risques considérer avant de commander.",
    cta: "Lire le Guide de Sécurité AllChinaBuy",
  },
  finalCta: {
    h2: "Commencez avec le Tableur AllChinaBuy",
    copy: "Recherchez des produits. Comparez les options. Comprenez le QC et l'expédition. Prenez de meilleures décisions d'achat.",
    ctaPrimary: "Explorer le Tableur AllChinaBuy",
    ctaSecondary: "Lire le Guide Débutant",
  },
  categoryButtons: {
    h2: "Parcourir les Catégories AllChinaBuy",
    copy: "Accédez directement à votre catégorie de produits préférée sur le magasin principal.",
  },
  productShowcase: {
    h2: "Produits en Vedette",
    copy: "Parcourez les produits sélectionnés du tableur AllChinaBuy. Cliquez sur n'importe quel article pour voir les détails et acheter sur le magasin principal.",
    viewAll: "Voir Tous les {{category}}",
  },
  productCard: {
    buyNow: "Acheter",
  },
  productDetail: {
    notFound: "Produit Non Trouvé",
    notFoundDesc: "Le produit que vous recherchez n'existe pas ou a été supprimé.",
    backHome: "Retour à l'Accueil",
    verified: "Annonce de Produit Vérifiée",
    qcAvailable: "Photos QC Disponibles",
    shippingGlobal: "Options d'Expédition Mondiales",
    buyNow: "Acheter — Aller au Magasin",
    viewCategory: "Voir Tout dans la Catégorie",
    redirectNotice: "Vous serez redirigé vers le magasin officiel pour finaliser votre achat.",
    relatedTitle: "Vous Aimerez Aussi",
  },
  ctaButtons: {
    allchinabuy: "AllChinaBuy Spreadsheet",
    buyNow: "Acheter Maintenant",
  },
  footer: {
    tagline: "AllChinaBuy Spreadsheet — Votre centre de recherche pour des décisions d'achat plus intelligentes.",
    links: {
      about: "À Propos",
      privacy: "Confidentialité",
      terms: "Conditions",
      contact: "Contact",
    },
    copyright: "© 2026 AllChinaBuy Spreadsheet. Tous droits réservés.",
  },
  lang: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
  article: {
    readMore: "Lire le Guide Complet",
    relatedArticles: "Articles Connexes",
  },
  faq: {
    h2: "Questions Fréquemment Posées",
    q1: "Qu'est-ce que le Tableur AllChinaBuy ?",
    a1: "Le tableur AllChinaBuy est une ressource organisée qui aide les acheteurs à découvrir des produits, rechercher des vendeurs, comparer les options et prendre des décisions d'achat éclairées.",
    q2: "Comment utiliser le Tableur AllChinaBuy ?",
    a2: "Commencez par parcourir les catégories qui correspondent à votre intérêt. Utilisez la fonction de recherche pour trouver des produits ou vendeurs spécifiques. Consultez les guides QC et d'expédition avant de passer des commandes.",
    q3: "AllChinaBuy est-il sûr à utiliser ?",
    a3: "La sécurité dépend de vos pratiques de recherche. Nos guides couvrent la protection du compte, la sécurité des paiements, l'évaluation des produits et les stratégies de réduction des risques.",
    q4: "Combien coûte l'expédition AllChinaBuy ?",
    a4: "Les coûts d'expédition varient selon la destination, le poids du colis, les dimensions et la méthode d'expédition choisie. Consultez notre guide d'expédition pour des détails complets.",
    q5: "AllChinaBuy propose-t-il des coupons ou des remises ?",
    a5: "Des coupons et promotions peuvent être disponibles périodiquement. Vérifiez toujours les offres actuelles et lisez les conditions avant d'appliquer un code de réduction.",
  },
};